module.exports = __webpack_public_path__ + "static/media/MICUENTA_azul.2b707007.svg";